import {
  configOption,
  configSubObject,
  KahunConfigurationOptionType,
} from "../lib/annotations";

export class PatientColors {
  @configOption({
    description:
      "Color of text in homepage landing page, and results disclaimer",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--homepage-text-color": string = "#FFFFFF";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--test-color": string = "#FFA07A";
  @configOption({
    description: "Main color of texts in the app",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--default": string = "#243443";
  @configOption({
    description: "Lighter color of texts in the app",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--default-light": string = "#F7F7F9";
  @configOption({
    description: "Darker color of texts in the app",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--default-dark": string = "#AAB0B7";
  @configOption({
    description: "Main color used for buttons and elements on the screen",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--primary": string = "#5A52C3";
  @configOption({
    description: "Lighter color used for buttons and elements on the screen",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--primary-light": string = "#E6E4FF";
  @configOption({
    description: "Darker color used for buttons and elements on the screen",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--primary-dark": string = "#651FAF";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--secondary": string = "#00AF91";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--background": string = "rgba(90, 82, 195, 0.2)";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--background2": string = "#D0CFE3";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--red": string = "#DE073C";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--emergency": string = "#A5334F";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--emergency-light": string = "rgba(165, 51, 79, 0.12)";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--urgent": string = "#E96B1E";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--urgent-light": string = "#FCEFE7";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--not-urgent": string = "#00A185";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--not-urgent-light": string = "#E1F4F1";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--orange": string = "#EA925C";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--green": string = "#06A489";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--disabled": string = "rgba(90, 82, 195, 0.3)";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--selected": string = "#5A52C3";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--unselected": string = "#F7F7F9";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--after-click-text": string = "#C5C3E4";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--after-click": string = "#292374";
  @configOption({
    description:
      "The background color of landing pages homepage or disclaimer page, if theme.gradient is turned on, this is the main color to which the gardiant will pass",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--grad-light": string = "#9F99EA";
  @configOption({
    description:
      "If theme.gradient is turned on, this is the color from which the gardiant will start in landing pages (homepage or results disclaimer)",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--grad-dark": string = "#5A52C3";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--header": string = "#E6E4FF";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--disabled-text": string = "#837DC8";
  @configOption({
    description: "Background color used in the organ map selections",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--organ-map-background": string = "#D0CEE3";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--symptom-icon-background": string = "#ffffff";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--symptom-character-color": string = "#DAD4FF";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--symptom-dark-body-lines": string = "#4841A8";
  @configOption({ displayType: KahunConfigurationOptionType.Color })
  "--symptom-light-body-lines": string = "#C8C1F2";
  @configOption({
    description:
      "White elements in the screen can be overrides, to black (in dark mode for instance)",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--white": string = "#FFFFFF";
  @configOption({
    description: "Color of the kahun link in homepage",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--homepage-link-color": string = "#FFFFFF";
  @configOption({
    description:
      "The color on the undo icon, if no undo icon was configured in the theme",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--undo": string = "#5A52C3";
  @configOption({
    description: "The color of the text of the answer boxes",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--answer-text-color": string = "#FFFFFF";
  @configOption({
    description: "The default color of the text indie the buttons",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--button-text-color": string = "#FFFFFF";
  @configOption({
    description: "The color of the terms agreement links in the landing page",
    displayType: KahunConfigurationOptionType.Color,
  })
  "--terms-link-color": string = "#5A52C3";
}

export class ThemeSettings {
  @configOption({})
  fontFamily?: string;

  @configOption({})
  bodyFontFamily?: string;

  @configOption({
    displayName: "App Icon",
    description:
      "The icon of the app that will be displayed in landing pages (main page and disclaimer)",
    displayType: KahunConfigurationOptionType.Image,
  })
  mainLogo: string = "";

  @configOption({
    description: "The icon of kahun that will be displayed next to Powered BY",
    displayType: KahunConfigurationOptionType.Image,
  })
  kahunLogo: string;

  @configOption({
    description:
      "What icon will be displayed next to the question asked by the bot",
    displayType: KahunConfigurationOptionType.Image,
  })
  botIcon: string = "kahunIcon.svg";

  @configOption({
    description: "What icon to show next to answerer as an undo answer",
    displayType: KahunConfigurationOptionType.Image,
  })
  arrowIcon: string = "";

  @configOption({
    description: "What icon to use for male charterers",
    displayType: KahunConfigurationOptionType.Image,
  })
  maleIcon: string = "";

  @configOption({
    description: "What icon to use for female charterers",
    displayType: KahunConfigurationOptionType.Image,
  })
  femaleIcon: string = "";

  @configOption({
    description:
      "Weather or not show a 'visit kahun' link under the apps main landing page",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showKahunLink: boolean = true;

  @configOption({
    description:
      "Use gradient in landing pages background (like home page or results disclaimer)",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  gradient?: boolean = true;

  @configSubObject({})
  colors?: PatientColors;

  @configOption({
    description: "Allows using an image as a background in main landing pages",
    displayType: KahunConfigurationOptionType.Image,
  })
  homepageBackgroundImageUrl?: string;
}
